import { AppThemeConstants } from './utils';
import Button from './components/button';
import RadioGroup from './components/radio-group';
import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';

const overrides = {
  components: {
    Button: Button,
    RadioGroup: RadioGroup,
  },
};

export const questTheme = extendTheme(
  overrides,
  withDefaultColorScheme({
    colorScheme: AppThemeConstants.PRIMARY_COLOR,
    components: ['Button', 'RadioGroup'],
  }),
);
